module.exports = __webpack_public_path__ + "img/制御工学5_1_2.783f4a49.png";